import { gql } from '@apollo/client';

export const QUERY_PICKUP_RESERVATION_DETAIL = gql`
  query QueryPickupReservationDetail($input: PickupDashboardDetailQueryInput!) {
    queryPickupReservationDetail(input: $input) {
      content {
        reservationNo
        reservatConfirmStatus
        reservatStatus
        reservatSource
        isWiring
        isVisit
        visitResult
        isTemu
        isExpected
        hubName
        siteId
        siteName
        vehicleType
        contactPhone
        customerName
        address
        source
        isNew
        continuousFailure
        routeName
        zipcode
        expectedPickupDate
        timezone
        expectedParcelCount
        expectedParcelUnit
        actualParcelCount
        actualParcelUnit
        expectedScanParcelCount
        actualScanParcelCount
        collectFailReason
        taskNumber
        updatedAt
      }
      page
      pageSize
      total
    }
  }
`;
